import { generatePath } from 'react-router-dom';

import { INVOICES } from '#client/constants/navItemsIds';
import * as ROUTES from '#client/constants/routes';

import { processMenu } from '../utils/menu';

/**
 * Get the Invoicing menu.
 *
 * @param {{
 *  businessEntityUuid: string
 *  order?: number
 *  entitlements: Set<string>
 * }} params
 * @returns {object}
 */
export function getInvoicingMenu({
  businessEntityUuid, order, entitlements
}) {
  const hasMoneyPro = entitlements.has('money_pro');
  const hasBanking = entitlements.has('banking');

  if (!hasBanking || hasMoneyPro) {
    return {};
  }

  return processMenu({
    title: 'Invoices',
    itemId: INVOICES,
    icon: 'receipt-list-fill.svg',
    path: generatePath(ROUTES.entityInvoicing, { businessEntityUuid }),
    order
  });
}
